module.exports = __webpack_public_path__ + "site/img/85.610690a3.jpg";